// extracted by mini-css-extract-plugin
var _1 = "Login_alternateActionButtonContainer__JTqyC";
var _2 = "Login_alternateActionText__nlxT8";
var _3 = "Login_button__Vlswy";
var _4 = "Login_formTitle__xnYyM";
var _5 = "Login_inputLabel__RMy0Y";
var _6 = "Login_loginWrapper__XW1w2";
var _7 = "Login_logo__yguB+";
var _8 = "Login_message__7MtXc";
var _9 = "Login_otherOptions__gzOp6";
var _a = "Login_otherOptionsLine__cUuCA";
var _b = "Login_otherOptionsText__p2ZyO";
var _c = "Login_otherOptionsTextWrapper__XUQ5a";
var _d = "Login_ssoIcon__+wGZV";
var _e = "Login_submitButton__fMHAq";
var _f = "Login_submitButtonIcon__l30Tq";
var _10 = "Login_wrapper__zYzT6";
export { _1 as "alternateActionButtonContainer", _2 as "alternateActionText", _3 as "button", _4 as "formTitle", _5 as "inputLabel", _6 as "loginWrapper", _7 as "logo", _8 as "message", _9 as "otherOptions", _a as "otherOptionsLine", _b as "otherOptionsText", _c as "otherOptionsTextWrapper", _d as "ssoIcon", _e as "submitButton", _f as "submitButtonIcon", _10 as "wrapper" }
